import { formatInTimeZone, fromZonedTime } from "date-fns-tz";
import { format } from "date-fns";

const PARIS_TZ = "Europe/Paris";

/**
 * DISPLAY: Single source of truth for showing times
 */
export const formatFranceDateTime = (
  isoString,
  mode = "friendly",
  options = {},
) => {
  if (!isoString) return "—";
  try {
    const d = new Date(isoString);
    let formatString;

    switch (mode) {
      case "date": // 27/03/2026
        formatString = "dd/MM/yyyy";
        break;
      case "time": // 10:30 (CET/CEST)
        formatString = "HH:mm (zzz)";
        break;
      case "full": // Admin Modal details
        formatString = "dd/MM/yyyy, HH:mm zzz (O)";
        break;
      case "friendly": // "Monday, 1 June 2026 at 03:30 CEST"
      default:
        const showYear = options.showYear !== false;
        formatString = `EEEE, d MMMM${showYear ? " yyyy" : ""} 'at' HH:mm zzz`;
        break;
    }
    return formatInTimeZone(d, PARIS_TZ, formatString);
  } catch {
    return "—";
  }
};

/**
 * PARSING: Used when opening Edit Modal to populate <input type="date/time">
 */
export const parseParisDatetime = (isoString) => {
  if (!isoString) return { date: "", time: "" };
  try {
    const d = new Date(isoString);
    return {
      date: formatInTimeZone(d, PARIS_TZ, "yyyy-MM-dd"),
      time: formatInTimeZone(d, PARIS_TZ, "HH:mm"),
    };
  } catch {
    return { date: "", time: "" };
  }
};

/**
 * CONVERTING: Used when SAVING (Create or Edit)
 * Handles both Date objects and YYYY-MM-DD strings.
 */
export const toParisISO = (dateOrStr, timeStr) => {
  if (!dateOrStr || !timeStr) return null;

  const datePart =
    typeof dateOrStr === "string" ? dateOrStr : format(dateOrStr, "yyyy-MM-dd");
  // 2. Parse numbers manually to completely avoid browser timezone parsing bugs
  const [year, month, day] = datePart.split("-").map(Number);
  const [hours, minutes] = timeStr.split(":").map(Number);

  // 3. Find exactly what the Paris offset is on this specific date
  // We use 12:00 PM as a safe anchor to check if it's summer (+02:00) or winter (+01:00)
  const approxDate = new Date(Date.UTC(year, month - 1, day, 12, 0));
  const offsetStr = formatInTimeZone(approxDate, PARIS_TZ, "xxx"); // Returns "+02:00" or "+01:00"

  // 4. Convert that offset into milliseconds
  const sign = offsetStr.startsWith("+") ? 1 : -1;
  const offsetHours = Number(offsetStr.slice(1, 3));
  const offsetMins = Number(offsetStr.slice(4, 6));
  const offsetMs = sign * (offsetHours * 60 + offsetMins) * 60 * 1000;

  // 5. Create a pure UTC date from the user's input, then subtract the Paris offset
  const naiveUtcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));
  const finalDate = new Date(naiveUtcDate.getTime() - offsetMs);

  return finalDate.toISOString();
};
